import { render, staticRenderFns } from "./ExhibitPage.vue?vue&type=template&id=15a74c6f&scoped=true&"
import script from "./ExhibitPage.vue?vue&type=script&lang=js&"
export * from "./ExhibitPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a74c6f",
  null
  
)

export default component.exports